import { TaktIdProvider, Text, ThemeProvider } from '@amzn/storm-ui';
import { TaktIdProvider as TaktIdProviderV3 } from '@amzn/storm-ui-v3';
import AppInitWrapper from '@flexible-reports/components/AppInitWrapper';
import store from '@flexible-reports/store/store';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { FlexibleReportsRoutes } from './flexible-reports-routes';
import '@urc-ui/services/i18n';
import '@flexible-reports/services/logger/katalLogger';
import { accountsApi } from '@flexible-reports/store/api/accounts/accounts';
import { metadataApi } from '@flexible-reports/store/api/metadata/metadata';
import { FieldType } from '@flexible-reports/store/api/metadata/types';
import { templatesApi } from '@flexible-reports/store/api/templates/templates';
import { isUnifiedReportingEnabled } from '@flexible-reports/utils/app-utils';

// Fetch accounts asynchronously outside App.
if (isUnifiedReportingEnabled()) {
  store.dispatch(
    accountsApi.endpoints.queryAccountHierarchies.initiate({
      accessScope: 'FULL_HIERARCHY'
    })
  );
} else {
  store.dispatch(accountsApi.endpoints.getManagerAccounts.initiate());
  store.dispatch(accountsApi.endpoints.getAdvertiserAccounts.initiate());
}
// Fetch metadata asynchronously outside App.
store.dispatch(
  metadataApi.endpoints?.queryReportingFields.initiate({
    typeFilter: { include: [FieldType.DIMENSION_ATTRIBUTE, FieldType.METRIC] }
  })
);

// Preload templates async
store.dispatch(templatesApi.endpoints.listTemplates.initiate());

const taktId = 'flexible-reports';

const mountingPoint = document.getElementById('flexible-reports') as HTMLElement;
const root = createRoot(mountingPoint);
const router = createBrowserRouter(FlexibleReportsRoutes(), { basename: '/reporting' });
mountingPoint.style.height = '100%';

root.render(
  <React.StrictMode>
    <AppInitWrapper>
      <TaktIdProvider taktId={taktId}>
        <TaktIdProviderV3 taktId={taktId}>
          <ThemeProvider>
            <Provider store={store}>
              {/* The Suspense component causes React to display the fallback KatSpinner until
                the i18n translation strings have been loaded. */}
              <React.Suspense fallback={<Text>Loading...</Text>}>
                <RouterProvider router={router} />
              </React.Suspense>
            </Provider>
          </ThemeProvider>
        </TaktIdProviderV3>
      </TaktIdProvider>
    </AppInitWrapper>
  </React.StrictMode>
);
